import { observer } from 'mobx-react';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MSLogo } from '../components/svg-icons/ms-logo';
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem
} from '@components/ui/sidebar';
import { NavGroup, Route, Routes } from '../core/routes';
import { SessionPanel } from './session-panel';
import { injectTSDI } from '../core/tsdi';

const groups: NavGroup[] = ['People', 'Sport', 'Catalog & Ops'];

export const AppSidebar = observer(() => {
    const { navLinks } = injectTSDI(Routes);
    const { pathname } = useLocation();

    const isActive = (route: Route) =>
        route.path === '/' ? pathname === '/' : pathname.startsWith(route.path);

    return (
        <Sidebar collapsible="icon">
            <SidebarHeader>
                <Link
                    to="/"
                    className="flex items-center gap-2 px-2 py-1 text-sidebar-foreground"
                >
                    <MSLogo className="size-8 shrink-0" />
                    <span className="truncate text-sm font-bold group-data-[collapsible=icon]:hidden">
                        Move Republic Admin
                    </span>
                </Link>
            </SidebarHeader>
            <SidebarContent>
                {groups.map((group) => {
                    const links = navLinks.filter(
                        (route) => (route.navGroup ?? 'Catalog & Ops') === group
                    );
                    if (links.length === 0) {
                        return null;
                    }
                    return (
                        <SidebarGroup key={group}>
                            <SidebarGroupLabel>{group}</SidebarGroupLabel>
                            <SidebarGroupContent>
                                <SidebarMenu>
                                    {links.map((route) => (
                                        <SidebarMenuItem key={route.path}>
                                            <SidebarMenuButton
                                                asChild
                                                isActive={isActive(route)}
                                                tooltip={route.title}
                                            >
                                                <Link to={route.path}>
                                                    {route.Icon && (
                                                        <route.Icon />
                                                    )}
                                                    <span>{route.title}</span>
                                                </Link>
                                            </SidebarMenuButton>
                                        </SidebarMenuItem>
                                    ))}
                                </SidebarMenu>
                            </SidebarGroupContent>
                        </SidebarGroup>
                    );
                })}
            </SidebarContent>
            <SidebarFooter className="p-0">
                <SessionPanel />
            </SidebarFooter>
        </Sidebar>
    );
});
